import { render, staticRenderFns } from "./customers.vue?vue&type=template&id=4908d21c&scoped=true&"
import script from "./customers.vue?vue&type=script&lang=js&"
export * from "./customers.vue?vue&type=script&lang=js&"
import style0 from "./customers.vue?vue&type=style&index=0&id=4908d21c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4908d21c",
  null
  
)

export default component.exports